import { render, staticRenderFns } from "./PointTopUpFailure.vue?vue&type=template&id=221e37b4"
import script from "./PointTopUpFailure.vue?vue&type=script&lang=js"
export * from "./PointTopUpFailure.vue?vue&type=script&lang=js"
import style0 from "./PointTopUpFailure.vue?vue&type=style&index=0&id=221e37b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports